import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=898d8e5a&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('898d8e5a')) {
      api.createRecord('898d8e5a', component.options)
    } else {
      api.reload('898d8e5a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=898d8e5a&", function () {
      api.rerender('898d8e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay/Index.vue"
export default component.exports